module.exports = __webpack_public_path__ + "static/img/zhuanli-3.fe3bc06d.png";